module.exports = __webpack_public_path__ + "media/images/athletes/3411-ba04788b971633b02ba8058b3637f8b4.png";